<template>
  <div style="height: 855px">
    <a-row :style="{padding: onMobile? '3px 10px':'30px',height: '100%'}" type="flex" justify="space-between">
      <a-col v-if="!(onMobile && viewVisible)" :span="onMobile? 24:4">
        <a-card hoverable>
          <a-layout style="height: 100%">
            <a-menu
                style="height: 100%;background-color: #fff"
                :default-selected-keys="[selectedMenu]"
                mode="inline"
                @click="handleClick"
            >
              <a-menu-item key="userInfo">
                <span class="titleClass">个人资料</span>
              </a-menu-item>
              <a-menu-item key="account">
                <span class="titleClass">账号与密码</span>
              </a-menu-item>
              <a-menu-item key="message" disabled>
                <span class="titleClass">消息与邮件</span>
              </a-menu-item>
              <a-menu-item key="music">
                <span class="titleClass">音乐</span>
              </a-menu-item>
              <a-menu-item key="configuration">
                <span class="titleClass">界面配置</span>
              </a-menu-item>
            </a-menu>
          </a-layout>
        </a-card>
      </a-col>
      <a-col v-if="viewVisible" :span="onMobile? 24:20" :style="{height: '100%',paddingLeft: onMobile?'0':'20px'}">
        <a-card hoverable style="height: 800px">
          <!--            <a-button size="small" icon="close" shape="circle" @click="closeView"-->
          <!--                      style="float: right;z-index: 9;margin: 5px"></a-button>-->
          <UserInformation v-if="selectedMenu === 'userInfo'"></UserInformation>
          <AccountConfiguration v-if="selectedMenu === 'account'"></AccountConfiguration>
          <MusicConfiguration v-if="selectedMenu === 'music'"></MusicConfiguration>
          <InterfaceConfiguration v-if="selectedMenu === 'configuration'"></InterfaceConfiguration>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import AccountConfiguration from "./AccountConfiguration";
import MusicConfiguration from "./MusicConfiguration";
import InterfaceConfiguration from "@/views/user/AccountSetting/InterfaceConfiguration";
import UserInformation from "@/views/user/UserInformation";

export default {
  name: "AccountSetting",
  components: {AccountConfiguration, MusicConfiguration, InterfaceConfiguration, UserInformation},
  data() {
    return {
      onMobile: this.$store.state.screenWidth < 576,
      viewVisible: true,
      selectedMenu: 'userInfo'
    };
  },
  methods: {
    handleClick(e) {
      this.viewVisible = true
      this.selectedMenu = e.key
    },
    // closeView() {
    //   this.viewVisible = false
    // }
  },
  watch: {
    '$store.state.screenWidth': function (newVal) {
      this.onMobile = newVal < 576
    },
  },
  created() {
    if (this.$route.params.selectedMenu) {
      this.selectedMenu = this.$route.params.selectedMenu
    }
  }
}
</script>

<style scoped>
.titleClass {
  text-align: center;
  font-weight: bold;
  font-size: 16px;
}
</style>